/*
  Aimer Atacado — Página de coleção, padrão v2.
  Sacola sem sair da página (contador no card, grade de tamanhos na ficha),
  lookbook "peças desta foto", vídeos das peças, filtros e revelação ao rolar.

  Observação de ambiente: IntersectionObserver e requestAnimationFrame não
  disparam em webviews/abas sem paint — toda lógica crítica tem reserva por
  setTimeout/scroll.
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-ac]');
  if (!raiz || raiz.dataset.acPronto) return;
  raiz.dataset.acPronto = '1';

  var $ = function (sel, el) { return (el || raiz).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || raiz).querySelectorAll(sel)); };
  var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Dados ------------------------------------------------------------ */
  var pecas = [];
  try { pecas = JSON.parse($('[data-ac-dados]').textContent) || []; } catch (e) { pecas = []; }
  var porId = {};
  var porVariante = {};
  pecas.forEach(function (p) {
    porId[p.id] = p;
    p.vs.forEach(function (v) { porVariante[v.id] = p; });
  });

  var moeda = raiz.dataset.moeda || 'BRL';
  var fmt;
  try { fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: moeda }); } catch (e) { fmt = null; }
  function dinheiro(centavos) {
    var v = (centavos || 0) / 100;
    return fmt ? fmt.format(v) : 'R$ ' + v.toFixed(2).replace('.', ',');
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ico(nome) {
    var t = $('template[data-ac-ico="' + nome + '"]');
    return t ? t.innerHTML : '';
  }
  function partesTitulo(t) {
    var sep = t.indexOf(' — ') > -1 ? ' — ' : (t.indexOf(' - ') > -1 ? ' - ' : null);
    if (!sep) return { nome: t, detalhe: '' };
    var i = t.indexOf(sep);
    return { nome: t.slice(0, i), detalhe: t.slice(i + sep.length) };
  }
  function largura(url, w) {
    return String(url).replace(/([?&])width=\d+/, '$1width=' + w);
  }

  /*
    Vídeos leves: no Liquid a Shopify só expõe o MP4 1080p. O endpoint
    /products/<handle>.js lista também 480p e 720p — buscamos sob demanda e
    guardamos em cache. Se falhar, segue com o 1080p que veio da página.
  */
  var cacheFontes = {};
  function fontesDe(produtoId) {
    if (cacheFontes[produtoId]) return cacheFontes[produtoId];
    var p = porId[produtoId];
    var handle = p && String(p.u).split('/products/')[1];
    if (!handle) return Promise.resolve({});
    handle = handle.split('?')[0].split('#')[0];
    cacheFontes[produtoId] = fetch((raiz.dataset.raiz || '/') + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        var mapa = {};
        (j.media || []).forEach(function (m) {
          if (m.media_type !== 'video') return;
          var mp4 = (m.sources || []).filter(function (f) { return f.format === 'mp4'; }).sort(function (a, b) { return a.height - b.height; });
          if (!mp4.length) return;
          var media = mp4.filter(function (f) { return f.height <= 720; }).pop() || mp4[0];
          mapa[m.id] = { leve: mp4[0].url, media: media.url };
        });
        return mapa;
      })
      .catch(function () { return {}; });
    return cacheFontes[produtoId];
  }
  function fonteVideo(produtoId, midiaId, reserva) {
    var celular = window.innerWidth < 750;
    return fontesDe(produtoId).then(function (mapa) {
      var f = mapa[midiaId];
      return f ? (celular ? f.leve : f.media) : reserva;
    });
  }

  /* ---- Revelação ao rolar ------------------------------------------------ */
  (function () {
    var itens = $$('.ac-revela');
    function mostra(el) { el.classList.add('is-visivel'); }
    if (reduz) { itens.forEach(mostra); return; }

    function confere() {
      var h = window.innerHeight || document.documentElement.clientHeight;
      itens = itens.filter(function (el) {
        if (el.closest('[hidden]')) return true;
        var r = el.getBoundingClientRect();
        if (r.top < h * 0.92 && r.bottom > -40) {
          var irmaos = Array.prototype.filter.call(el.parentNode.children, function (n) {
            return n.classList && n.classList.contains('ac-revela') && !n.classList.contains('is-visivel');
          });
          el.style.transitionDelay = Math.min(irmaos.indexOf(el), 5) * 70 + 'ms';
          mostra(el);
          return false;
        }
        return true;
      });
    }
    var espera = null;
    function agenda() {
      if (espera) return;
      espera = window.setTimeout(function () { espera = null; confere(); }, 60);
    }
    window.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
    confere();
    window.setTimeout(confere, 400);
    raiz._acConfere = confere;
  })();

  /* ---- Filme de lançamento ------------------------------------------------ */
  (function () {
    var bloco = $('[data-ac-filme]');
    if (!bloco) return;
    var botao = $('[data-ac-filme-play]', bloco);
    var tpl = $('[data-ac-filme-tpl]', bloco);
    function toca() {
      if (!botao || !tpl || bloco.classList.contains('is-tocando')) return;
      var quadro = $('.ac-filme__quadro', bloco);
      quadro.appendChild(tpl.content.cloneNode(true));
      bloco.classList.add('is-tocando');
      botao.remove();
      var v = $('video', quadro);
      if (v) {
        v.setAttribute('playsinline', '');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    if (botao) botao.addEventListener('click', toca);
    var ir = $('[data-ac-filme-ir]');
    if (ir) {
      ir.addEventListener('click', function (e) {
        e.preventDefault();
        bloco.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(toca, reduz ? 0 : 650);
      });
    }
  })();

  /* ---- Trilhos horizontais com setas -------------------------------------- */
  function ligaSetas() {
    $$('[data-ac-setas]').forEach(function (grupo) {
      if (grupo.dataset.ligado) return;
      var trilho = document.getElementById(grupo.dataset.acSetas);
      if (!trilho) return;
      grupo.dataset.ligado = '1';
      var botoes = $$('button', grupo);
      function estado() {
        var max = trilho.scrollWidth - trilho.clientWidth - 4;
        botoes.forEach(function (b) {
          b.disabled = b.dataset.dir === '-1' ? trilho.scrollLeft <= 4 : trilho.scrollLeft >= max;
        });
      }
      botoes.forEach(function (b) {
        b.addEventListener('click', function () {
          var passo = Math.max(280, trilho.clientWidth * 0.7) * Number(b.dataset.dir);
          trilho.scrollBy({ left: passo, behavior: reduz ? 'auto' : 'smooth' });
          window.setTimeout(estado, 500);
        });
      });
      trilho.addEventListener('scroll', function () { window.clearTimeout(trilho._t); trilho._t = window.setTimeout(estado, 80); }, { passive: true });
      estado();
    });
  }
  ligaSetas();

  /* ---- Pontinhos das galerias de arrastar --------------------------------- */
  function ligaPontos(trilho, pontos) {
    if (!trilho || !pontos.length) return;
    trilho.addEventListener('scroll', function () {
      window.clearTimeout(trilho._p);
      trilho._p = window.setTimeout(function () {
        var i = Math.round(trilho.scrollLeft / Math.max(1, trilho.clientWidth));
        pontos.forEach(function (p, n) { p.classList.toggle('is-ativo', n === i); });
        if (trilho._aoMudar) trilho._aoMudar(i);
      }, 60);
    }, { passive: true });
  }
  $$('[data-ac-card]').forEach(function (card) {
    ligaPontos($('[data-ac-trilho]', card), $$('.ac-card__pontos i', card));
  });

  /* ---- Filtros por tipo + "ver mais" -------------------------------------- */
  (function () {
    var chips = $$('[data-ac-filtro]');
    var cards = $$('[data-ac-card]');
    var respiros = $$('[data-ac-respiro]');
    var vazio = $('[data-ac-vazio]');
    var maisWrap = $('[data-ac-mais-wrap]');
    var maisBtn = $('[data-ac-ver-mais]');
    var filtro = 'todas';

    function aplica() {
      var n = 0;
      cards.forEach(function (c) {
        var bate = filtro === 'todas' || c.dataset.tipo === filtro;
        var extra = c.hasAttribute('data-ac-extra');
        c.hidden = !bate || (filtro === 'todas' && extra);
        if (!c.hidden) n++;
      });
      respiros.forEach(function (r) { r.hidden = filtro !== 'todas'; });
      if (vazio) vazio.hidden = n > 0;
      if (maisWrap) maisWrap.hidden = filtro !== 'todas' || !$$('[data-ac-extra]').length;
      if (raiz._acConfere) raiz._acConfere();
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filtro = chip.dataset.acFiltro;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-ativo', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        aplica();
      });
    });
    if (maisBtn) {
      maisBtn.addEventListener('click', function () {
        var passo = Number(maisBtn.dataset.passo) || 48;
        var extras = $$('[data-ac-extra]');
        extras.slice(0, passo).forEach(function (c) { c.removeAttribute('data-ac-extra'); c.hidden = false; });
        var restam = extras.length - Math.min(passo, extras.length);
        var em = $('[data-ac-restam]', maisBtn);
        if (em) em.textContent = restam;
        if (!restam && maisWrap) maisWrap.hidden = true;
        if (raiz._acConfere) raiz._acConfere();
      });
    }
  })();

  /* ==========================================================================
     SACOLA
     ========================================================================== */
  var rotas = window.routes || {};
  var raizUrl = raiz.dataset.raiz || '/';
  var URL_ADD = (rotas.cart_add_url || raizUrl + 'cart/add') + '.js';
  var URL_CHANGE = (rotas.cart_change_url || raizUrl + 'cart/change') + '.js';
  var URL_CART = (rotas.cart_url || raizUrl + 'cart') + '.js';

  var qtds = {};            // variante -> quantidade na sacola
  var carrinho = { item_count: 0, total_price: 0 };
  var fila = Promise.resolve();
  var pendentes = {};       // variante -> timer de envio

  function pedido(url, corpo) {
    return fetch(url, {
      method: corpo ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: corpo ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: corpo ? JSON.stringify(corpo) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var erro = new Error(j.description || j.message || 'Não foi possível atualizar a sacola.'); erro.dados = j; throw erro; }
        return j;
      });
    });
  }

  function leCarrinho(c) {
    carrinho = c;
    qtds = {};
    (c.items || []).forEach(function (it) { qtds[it.variant_id] = (qtds[it.variant_id] || 0) + it.quantity; });
  }

  function sincroniza() {
    return pedido(URL_CART).then(function (c) { leCarrinho(c); pintaTudo(); });
  }

  var toastTimer = null;
  function avisa(msg) {
    var t = $('[data-ac-toast]') || document.querySelector('[data-ac-toast]');
    if (!t) return;
    var ficha = document.querySelector('[data-ac-ficha]');
    (ficha && ficha.open ? ficha : raiz).appendChild(t);
    t.textContent = msg;
    t.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { t.hidden = true; }, 3600);
  }

  /* Bolha do carrinho no cabeçalho do tema (Dawn) — atualiza sem abrir nada */
  function atualizaBolha() {
    var alvo = document.getElementById('cart-icon-bubble');
    if (!alvo) return;
    fetch(raizUrl + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-icon-bubble'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('.shopify-section') || doc.body;
        alvo.innerHTML = novo.innerHTML;
      })
      .catch(function () {});
  }

  function maxDe(varianteId) {
    var p = porVariante[varianteId];
    if (!p) return null;
    for (var i = 0; i < p.vs.length; i++) if (p.vs[i].id === Number(varianteId)) return p.vs[i].q;
    return null;
  }

  /* Pinta um contador (card, ficha ou lista) conforme qtds */
  function pintaQtd(el) {
    var id = el.dataset.variante;
    var q = qtds[id] || 0;
    var add = $('[data-ac-add]', el);
    var passos = $('.ac-qtd__passos', el);
    var valor = $('[data-ac-valor]', el);
    var fixo = el.hasAttribute('data-ac-fixo');     // grade de tamanhos: contador sempre visível
    if (add) add.hidden = q > 0;
    if (passos) passos.hidden = !fixo && q === 0;
    if (valor) valor.innerHTML = fixo ? '<b>' + q + '</b>' : '<b>' + q + '</b><span> na sacola</span>';
    el.classList.toggle('tem-qtd', q > 0);
    var max = el.dataset.max === '' || el.dataset.max == null ? null : Number(el.dataset.max);
    var mais = $('[data-ac-mais]', el);
    var menos = $('[data-ac-menos]', el);
    if (mais) mais.disabled = max != null && q >= max;
    if (menos) menos.disabled = fixo && q === 0;
  }

  function pintaSacola(pulso) {
    var barra = $('[data-ac-sacola]');
    if (!barra) return;
    var n = carrinho.item_count || 0;
    barra.hidden = n === 0;
    raiz.classList.toggle('tem-sacola', n > 0);
    $('[data-ac-sacola-qtd]', barra).textContent = n;
    $('[data-ac-sacola-resumo]', barra).textContent = n + (n === 1 ? ' peça · ' : ' peças · ') + dinheiro(carrinho.total_price);
    var minimo = Number(raiz.dataset.minimo) || 0;
    var apoio = $('[data-ac-sacola-apoio]', barra);
    var prog = $('[data-ac-sacola-progresso]', barra);
    if (minimo > 0) {
      var falta = minimo - n;
      apoio.textContent = falta > 0
        ? (falta === 1 ? 'Falta 1 peça para o pedido mínimo' : 'Faltam ' + falta + ' para o pedido mínimo')
        : 'Pedido mínimo atingido';
      prog.hidden = false;
      $('i', prog).style.width = Math.min(100, Math.round((n / minimo) * 100)) + '%';
    } else {
      apoio.textContent = '';
      prog.hidden = true;
    }
    if (pulso) {
      barra.classList.remove('is-pulso');
      void barra.offsetWidth;
      barra.classList.add('is-pulso');
    }
  }

  function pintaContas() {
    $$('[data-ac-conta]', document).forEach(function (em) {
      var p = porId[em.dataset.acConta];
      if (!p) return;
      var soma = p.vs.reduce(function (s, v) { return s + (qtds[v.id] || 0); }, 0);
      em.hidden = soma === 0;
      em.textContent = soma;
    });
    var total = document.querySelector('[data-ac-ficha-total]');
    if (total) {
      var pt = porId[total.dataset.acFichaTotal];
      var s = pt ? pt.vs.reduce(function (a, v) { return a + (qtds[v.id] || 0); }, 0) : 0;
      total.innerHTML = s > 0 ? '<b>' + s + (s === 1 ? ' peça' : ' peças') + '</b> desta joia na sacola' : '';
    }
  }

  function pintaTudo(pulso) {
    $$('[data-ac-qtd]', document).forEach(pintaQtd);
    pintaContas();
    pintaSacola(pulso);
  }

  /* Define a quantidade de uma variante: otimista na tela, envio agrupado */
  function defineQtd(varianteId, nova, origem) {
    varianteId = String(varianteId);
    var max = maxDe(varianteId);
    if (max != null && nova > max) {
      nova = Math.max(0, max);
      avisa(max <= 0 ? 'Esta peça está esgotada.' : (max === 1 ? 'Só temos 1 peça em estoque.' : 'Só temos ' + max + ' peças em estoque.'));
    }
    nova = Math.max(0, nova);
    var antes = qtds[varianteId] || 0;
    if (nova === antes) return;

    carrinho.item_count = Math.max(0, (carrinho.item_count || 0) + (nova - antes));
    var p = porVariante[varianteId];
    var preco = 0;
    if (p) p.vs.forEach(function (v) { if (String(v.id) === varianteId) preco = v.p; });
    carrinho.total_price = Math.max(0, (carrinho.total_price || 0) + (nova - antes) * preco);
    qtds[varianteId] = nova;
    pintaTudo(nova > antes);

    if (origem && nova > antes) {
      origem.classList.remove('is-brilho');
      void origem.offsetWidth;
      origem.classList.add('is-brilho');
    }

    window.clearTimeout(pendentes[varianteId]);
    pendentes[varianteId] = window.setTimeout(function () { envia(varianteId); }, 380);
  }

  var emFila = 0;          // envios aguardando/rodando — enquanto houver, a tela é a fonte da verdade
  function envia(varianteId) {
    delete pendentes[varianteId];
    emFila++;
    fila = fila.then(function () {
      var alvo = qtds[varianteId] || 0;
      return pedido(URL_CART).then(function (c) {
        var atual = 0;
        (c.items || []).forEach(function (it) { if (String(it.variant_id) === varianteId) atual += it.quantity; });
        if (alvo === atual) return c;
        if (atual === 0) return pedido(URL_ADD, { items: [{ id: Number(varianteId), quantity: alvo }] }).then(function () { return pedido(URL_CART); });
        return pedido(URL_CHANGE, { id: varianteId, quantity: alvo });
      }).then(function (c) {
        emFila--;
        // Só adota o carrinho do servidor quando não há toques nem envios pendentes
        if (!emFila && !Object.keys(pendentes).length) { leCarrinho(c); pintaTudo(); }
        atualizaBolha();
      }).catch(function (erro) {
        emFila--;
        avisa(erro.message || 'Não foi possível atualizar a sacola.');
        if (emFila || Object.keys(pendentes).length) return;
        return sincroniza().then(atualizaBolha);
      });
    });
  }

  /* Cliques de compra (delegados — valem para card, ficha, lista e vídeos) */
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest('[data-ac-add], [data-ac-mais], [data-ac-menos]');
    if (!alvo) return;
    var caixa = alvo.closest('[data-ac-qtd]');
    if (!caixa || !(raiz.contains(caixa) || caixa.closest('[data-ac-ficha]'))) return;
    e.preventDefault();
    var id = caixa.dataset.variante;
    var q = qtds[id] || 0;
    defineQtd(id, alvo.hasAttribute('data-ac-menos') ? q - 1 : q + 1, caixa);
  });

  /* ==========================================================================
     FICHA RÁPIDA
     ========================================================================== */
  var ficha = $('[data-ac-ficha]');
  var fichaConteudo = $('[data-ac-ficha-conteudo]');
  var ultimoFoco = null;
  var lookAtual = null;

  function htmlQtd(v, titulo, fixo) {
    var max = v.q == null ? '' : v.q;
    return '<div class="ac-qtd" data-ac-qtd ' + (fixo ? 'data-ac-fixo ' : '') + 'data-variante="' + v.id + '" data-max="' + max + '">' +
      (fixo ? '' : '<button type="button" class="ac-btn-card" data-ac-add>' + ico('mais') + '<span>Adicionar</span></button>') +
      '<div class="ac-qtd__passos"' + (fixo ? '' : ' hidden') + '>' +
        '<button type="button" data-ac-menos aria-label="Diminuir quantidade de ' + esc(titulo) + '">' + ico('menos') + '</button>' +
        '<output data-ac-valor aria-live="polite"><b>0</b></output>' +
        '<button type="button" data-ac-mais aria-label="Aumentar quantidade de ' + esc(titulo) + '">' + ico('mais') + '</button>' +
      '</div></div>';
  }

  function htmlGaleria(slides) {
    var h = '<div class="ac-ficha__midia"><div class="ac-ficha__galeria" data-ac-galeria>';
    slides.forEach(function (s) {
      if (s.tipo === 'video') {
        h += '<div class="ac-ficha__slide ac-ficha__slide--video"><video data-reserva="' + esc(s.src) + '" data-produto="' + esc(s.pid || '') + '" data-midia="' + esc(s.mid || '') + '" poster="' + esc(s.capa) + '" muted loop playsinline controls preload="none"></video></div>';
      } else {
        h += '<div class="ac-ficha__slide' + (s.tipo === 'still' ? ' ac-ficha__slide--still' : '') + '"><img src="' + esc(largura(s.src, 1000)) + '" alt="' + esc(s.alt) + '" loading="lazy"></div>';
      }
    });
    h += '</div>';
    if (slides.length > 1) {
      h += '<button type="button" class="ac-ficha__nav" data-dir="-1" aria-label="Mídia anterior">' + ico('seta-esq') + '</button>' +
           '<button type="button" class="ac-ficha__nav" data-dir="1" aria-label="Próxima mídia">' + ico('seta') + '</button>' +
           '<div class="ac-ficha__pontos">' + slides.map(function (s, i) { return '<i' + (i === 0 ? ' class="is-ativo"' : '') + '></i>'; }).join('') + '</div>';
    }
    return h + '</div>';
  }

  function ligaGaleria() {
    var g = $('[data-ac-galeria]', fichaConteudo);
    if (!g) return;
    var pontos = $$('.ac-ficha__pontos i', fichaConteudo);
    var navs = $$('.ac-ficha__nav', fichaConteudo);
    var total = g.children.length;
    function estado(i) {
      navs.forEach(function (b) { b.disabled = b.dataset.dir === '-1' ? i <= 0 : i >= total - 1; });
      $$('video', g).forEach(function (v, n) {
        var slide = v.closest('.ac-ficha__slide');
        var ativo = Array.prototype.indexOf.call(g.children, slide) === i;
        if (!ativo) { v.pause(); return; }
        function toca() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        if (v.getAttribute('src')) { toca(); return; }
        fonteVideo(v.dataset.produto, v.dataset.midia, v.dataset.reserva).then(function (url) {
          if (!v.isConnected) return;
          v.src = url || v.dataset.reserva;
          toca();
        });
      });
    }
    g._aoMudar = estado;
    ligaPontos(g, pontos);
    navs.forEach(function (b) {
      b.addEventListener('click', function () {
        g.scrollBy({ left: g.clientWidth * Number(b.dataset.dir), behavior: reduz ? 'auto' : 'smooth' });
      });
    });
    estado(0);
  }

  function abreFicha() {
    if (!ficha) return;
    if (!ficha.open) {
      ultimoFoco = document.activeElement;
      if (typeof ficha.showModal === 'function') ficha.showModal(); else ficha.setAttribute('open', '');
      document.documentElement.classList.add('ac-travado');
    }
    var caixa = $('.ac-ficha__caixa', ficha);
    if (caixa) caixa.scrollTop = 0;
    pintaTudo();
    ligaGaleria();
  }

  function fechaFicha() {
    if (!ficha || !ficha.open) return;
    $$('video', fichaConteudo).forEach(function (v) { v.pause(); });
    if (typeof ficha.close === 'function') ficha.close(); else ficha.removeAttribute('open');
  }
  if (ficha) {
    ficha.addEventListener('close', function () {
      document.documentElement.classList.remove('ac-travado');
      fichaConteudo.innerHTML = '';
      lookAtual = null;
      var t = document.querySelector('[data-ac-toast]');
      if (t) raiz.appendChild(t);
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    });
    ficha.addEventListener('click', function (e) { if (e.target === ficha) fechaFicha(); });
    $('[data-ac-ficha-fechar]', ficha).addEventListener('click', fechaFicha);
  }

  function fichaPeca(id, foco, voltarPara) {
    var p = porId[id];
    if (!p) return;
    var t = partesTitulo(p.t);
    var slides = [];
    var videos = (p.vd || []).map(function (v) { return { tipo: 'video', src: v.hd || v.sd, capa: v.c, pid: p.id, mid: v.k }; });
    if (foco === 'video') slides = slides.concat(videos);
    if (p.img) slides.push({ tipo: 'still', src: p.img, alt: p.t });
    (p.fs || []).forEach(function (f) { slides.push({ tipo: 'foto', src: f.s, alt: f.a }); });
    if (foco !== 'video') slides = slides.concat(videos);

    var h = htmlGaleria(slides) + '<div class="ac-ficha__info">';
    if (voltarPara) h += '<button type="button" class="ac-ficha__voltar" data-ac-voltar>' + ico('seta-esq') + '<span>Peças desta foto</span></button>';
    h += '<h3 class="ac-ficha__nome">' + esc(t.nome) + '</h3>';
    if (t.detalhe) h += '<p class="ac-ficha__pedra">' + esc(t.detalhe) + '</p>';

    h += '<div class="ac-ficha__precos"><div><small>Atacado</small><b>' + dinheiro(p.p) + '</b></div>';
    if (p.r > p.p) {
      h += '<div><small>Varejo sugerido</small><b>' + dinheiro(p.r) + '</b></div>' +
           '<div class="is-margem"><small>Sua margem</small><b>' + dinheiro(p.r - p.p) + '</b></div>';
    }
    h += '</div>';

    if (!p.a) {
      h += '<div class="ac-ficha__unica"><span class="ac-btn-card ac-btn-card--off">Esgotado</span></div>';
    } else if (p.un) {
      h += '<div class="ac-ficha__unica">' + htmlQtd(p.vs[0], p.t, false) + '</div>';
    } else {
      h += '<div class="ac-tamanhos"><h4>' + esc(p.op) + ' <span>escolha quantas de cada</span></h4>';
      p.vs.forEach(function (v) {
        var nota = '';
        if (!v.a) nota = 'Esgotado';
        else if (v.q != null && v.q > 0 && v.q <= 3) nota = v.q === 1 ? 'Última peça' : 'Últimas ' + v.q;
        h += '<div class="ac-tamanhos__linha' + (v.a ? '' : ' is-off') + '">' +
               '<div class="ac-tamanhos__rotulo"><b>' + esc(v.t) + '</b>' + (nota ? '<span>' + nota + '</span>' : '') + '</div>' +
               (v.a ? htmlQtd(v, p.t + ' — ' + v.t, true) : '<span></span>') +
             '</div>';
      });
      h += '</div>';
    }

    h += '<div class="ac-ficha__rodape"><p class="ac-ficha__total" data-ac-ficha-total="' + p.id + '"></p>' +
         '<a class="ac-ficha__link" href="' + esc(p.u) + '"><span>Ver página da peça</span>' + ico('seta') + '</a></div></div>';

    ficha.classList.remove('ac-ficha--look');
    ficha.setAttribute('aria-label', 'Ficha rápida: ' + p.t);
    fichaConteudo.innerHTML = h;
    var voltar = $('[data-ac-voltar]', fichaConteudo);
    if (voltar) voltar.addEventListener('click', function () { fichaLook(voltarPara); });
    abreFicha();
  }

  /* "Peças desta foto" (ou deste vídeo): midia = { tipo, src, capa, alt, ids[] } */
  function fichaLook(midia) {
    lookAtual = midia;
    var lista = midia.ids.map(function (id) { return porId[id]; }).filter(Boolean);
    if (lista.length === 1 && midia.tipo !== 'foto') { fichaPeca(lista[0].id, 'video'); return; }

    var h = htmlGaleria([midia]) + '<div class="ac-ficha__info">' +
      '<p class="ac-eyebrow"><span class="ac-eyebrow__losango" aria-hidden="true"></span>' + (midia.tipo === 'video' ? 'Peças deste vídeo' : 'Peças desta foto') + '</p>' +
      '<ul class="ac-lista" role="list">';
    lista.forEach(function (p) {
      var t = partesTitulo(p.t);
      h += '<li class="ac-lista__item">' +
        '<a class="ac-lista__thumb" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(largura(p.img, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<a class="ac-lista__nome" href="' + esc(p.u) + '"><b>' + esc(t.nome) + '</b><span>' + (t.detalhe ? esc(t.detalhe) + ' · ' : '') + '<em>' + dinheiro(p.p) + '</em></span></a>' +
        '<div class="ac-lista__acao">';
      if (!p.a) h += '<span class="ac-btn-card ac-btn-card--off">Esgotado</span>';
      else if (p.un) h += htmlQtd(p.vs[0], p.t, false);
      else h += '<button type="button" class="ac-btn-card ac-btn-card--contorno" data-ac-abrir="' + p.id + '" data-ac-foco="grade" data-ac-do-look><span>Escolher ' + esc(String(p.op).toLowerCase()) + '</span><em class="ac-btn-card__conta" data-ac-conta="' + p.id + '" hidden></em></button>';
      h += '</div></li>';
    });
    h += '</ul></div>';

    ficha.classList.add('ac-ficha--look');
    ficha.setAttribute('aria-label', midia.tipo === 'video' ? 'Peças deste vídeo' : 'Peças desta foto');
    fichaConteudo.innerHTML = h;
    abreFicha();
  }

  /* Abrir ficha de peça (card, lista) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ac-abrir]');
    if (!b) return;
    e.preventDefault();
    fichaPeca(b.dataset.acAbrir, b.dataset.acFoco, b.hasAttribute('data-ac-do-look') ? lookAtual : null);
  });

  /* Lookbook: foto -> peças que têm essa mesma foto */
  $$('[data-ac-look]').forEach(function (b) {
    b.addEventListener('click', function () {
      var chave = b.dataset.acLook;
      var ids = pecas.filter(function (p) { return (p.fs || []).some(function (f) { return f.k === chave; }); }).map(function (p) { return p.id; });
      var img = $('img', b);
      if (!ids.length) return;
      fichaLook({ tipo: 'foto', src: img.currentSrc || img.src, alt: img.alt, ids: ids });
    });
  });

  /* ==========================================================================
     EM MOVIMENTO — vídeos das peças
     ========================================================================== */
  (function () {
    var secao = $('[data-ac-reels]');
    var trilho = $('[data-ac-reels-trilho]');
    if (!secao || !trilho) return;

    var mapa = {};
    var ordem = [];
    pecas.forEach(function (p) {
      (p.vd || []).forEach(function (v) {
        if (!mapa[v.k]) { mapa[v.k] = { k: v.k, ar: v.ar, c: v.c, sd: v.sd, hd: v.hd, ids: [] }; ordem.push(mapa[v.k]); }
        mapa[v.k].ids.push(p.id);
      });
    });
    var verticais = ordem.filter(function (v) { return v.ar < 0.8; });
    var lista = verticais.length >= 3 ? verticais : ordem.filter(function (v) { return v.ar >= 0.8; });
    if (verticais.length < 3) secao.classList.add('ac-reels--quadrado');
    lista = lista.slice(0, Number(trilho.dataset.max) || 10);
    if (lista.length < 3) return;

    trilho.innerHTML = lista.map(function (v, i) {
      var p = porId[v.ids[0]];
      var varias = v.ids.length > 1;
      var t = partesTitulo(p.t);
      var nome = varias ? v.ids.length + ' peças neste vídeo' : t.nome;
      var sub = varias ? 'Toque para ver' : (t.detalhe ? t.detalhe + ' · ' : '') + dinheiro(p.p);
      return '<li><div class="ac-reel" data-ac-reel="' + i + '">' +
        '<img class="ac-reel__capa" src="' + esc(v.c) + '" alt="" loading="lazy">' +
        '<video muted loop playsinline preload="none" data-src="' + esc(v.sd) + '" aria-label="Vídeo: ' + esc(nome) + '"></video>' +
        '<button type="button" class="ac-reel__toque" data-ac-reel-toque aria-label="Tocar ou pausar o vídeo">' + ico('play') + '</button>' +
        '<button type="button" class="ac-reel__som" data-ac-reel-som aria-label="Ligar o som">' + ico('mudo') + '</button>' +
        '<div class="ac-reel__base">' +
          '<a class="ac-reel__nome" href="' + esc(varias ? '#' : p.u) + '"' + (varias ? ' data-ac-reel-ver' : '') + '><b>' + esc(nome) + '</b><span>' + esc(sub) + '</span></a>' +
          '<button type="button" class="ac-reel__add" data-ac-reel-ver aria-label="Ver e adicionar à sacola">' + ico('sacola') + '</button>' +
        '</div></div></li>';
    }).join('');
    secao.hidden = false;
    ligaSetas();

    var reels = $$('[data-ac-reel]', trilho);
    function toca(r, exclusivo) {
      var v = $('video', r);
      var dados = lista[Number(r.dataset.acReel)];
      if (exclusivo) reels.forEach(function (o) { if (o !== r) pausa(o); });
      r.dataset.quer = '1';
      function vai() {
        if (r.dataset.quer !== '1') return;
        var p = v.play();
        r.classList.add('is-tocando');
        if (p && p.catch) p.catch(function () { r.classList.remove('is-tocando'); });
      }
      if (v.getAttribute('src')) { vai(); return; }
      fonteVideo(dados.ids[0], dados.k, v.dataset.src).then(function (url) {
        if (!v.getAttribute('src')) v.src = url || v.dataset.src;
        vai();
      });
    }
    function pausa(r) {
      var v = $('video', r);
      r.dataset.quer = '0';
      if (!v.paused) v.pause();
      r.classList.remove('is-tocando');
    }
    reels.forEach(function (r) {
      var dados = lista[Number(r.dataset.acReel)];
      $('[data-ac-reel-toque]', r).addEventListener('click', function () {
        if (r.classList.contains('is-tocando')) pausa(r); else toca(r, window.innerWidth < 750);
      });
      $('[data-ac-reel-som]', r).addEventListener('click', function (e) {
        var v = $('video', r);
        v.muted = !v.muted;
        e.currentTarget.innerHTML = ico(v.muted ? 'mudo' : 'som');
        e.currentTarget.setAttribute('aria-label', v.muted ? 'Ligar o som' : 'Desligar o som');
      });
      $$('[data-ac-reel-ver]', r).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          pausa(r);
          fichaLook({ tipo: 'video', src: dados.hd || dados.sd, capa: dados.c, alt: '', ids: dados.ids, pid: dados.ids[0], mid: dados.k });
        });
      });
    });

    /* Toca sozinho o vídeo mais visível (só onde há IntersectionObserver com paint) */
    if ('IntersectionObserver' in window && !reduz) {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.75) toca(en.target);
          else pausa(en.target);
        });
      }, { threshold: [0, 0.75] });
      reels.forEach(function (r) { io.observe(r); });
    }
  })();

  /* ---- Partida ------------------------------------------------------------ */
  sincroniza().catch(function () {});
  window.addEventListener('pageshow', function (e) { if (e.persisted) sincroniza().catch(function () {}); });
})();
